

export function SET_FASES(state, list) {
  state.fases = list;
}
